/**
 * The gold "Repo news" card: the newest nightly digest, shown on top of the
 * Deck until it was opened once. The 📰 chip in the header reopens the full
 * digest (with history) at any time — the card never disappears for good.
 */

import type { NewsEntry } from "../lib/news";

export function NewsCard({ entry, onOpen }: { entry: NewsEntry; onOpen: () => void }) {
  const stamp = entry.generatedAt.replace("T", " ").slice(0, 16);
  return (
    <button
      onClick={onOpen}
      className="card relative w-full border-2 border-gold/50 p-4 text-left"
    >
      <div className="flex flex-wrap items-center gap-1.5">
        <span className="chip bg-gold/15 text-gold">📰 Repo news</span>
        {stamp && <span className="chip bg-ink-850 text-ink-500">{stamp}</span>}
        {entry.agents && <span className="chip bg-ink-850 text-ink-500">{entry.agents}</span>}
      </div>
      {entry.overall && (
        <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-ink-300">{entry.overall}</p>
      )}
      <p className="mt-2 text-xs text-ink-500">
        {entry.domains.length} domain{entry.domains.length === 1 ? "" : "s"} — tap for what
        changed and what waits
      </p>
    </button>
  );
}
